/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MortalityWidgetResponse } from '../../models/mortality-widget-response';

export interface GetMortalityWidgetResponse$Params {
  harvestId: number;
  groupIdx?: Array<number>;
}

export function getMortalityWidgetResponse(http: HttpClient, rootUrl: string, params: GetMortalityWidgetResponse$Params, context?: HttpContext): Observable<StrictHttpResponse<MortalityWidgetResponse>> {
  const rb = new RequestBuilder(rootUrl, getMortalityWidgetResponse.PATH, 'get');
  if (params) {
    rb.path('harvestId', params.harvestId, {});
    rb.query('groupIdx', params.groupIdx, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MortalityWidgetResponse>;
    })
  );
}

getMortalityWidgetResponse.PATH = '/api/harvests/{harvestId}/mortality-widget';
